import {
  GET_POPUP_PENDING,
  GET_POPUP_SUCCESS,
  GET_POPUP_FAIL,
  SAVE_SELECTION_PENDING,
  SAVE_SELECTION_SUCCESS,
  SAVE_SELECTION_FAIL,
} from './mutation-types';

export default {
  [GET_POPUP_PENDING](state) {
    state.isLoading.popup = true;
    state.errors.popup = null;
  },

  [GET_POPUP_SUCCESS](state, payload) {
    state.isLoading.popup = false;
    state.popupData = payload;
    state.isShow = payload?.isShow ?? false;
  },

  [GET_POPUP_FAIL](state, error) {
    state.isLoading.popup = false;
    state.errors.popup = error;
  },

  [SAVE_SELECTION_PENDING](state) {
    state.isLoading.save = true;
    state.errors.save = null;
  },

  [SAVE_SELECTION_SUCCESS](state) {
    state.isLoading.save = false;
    state.isShow = false;
  },

  [SAVE_SELECTION_FAIL](state, error) {
    state.isLoading.save = false;
    state.errors.save = error;
  },
};
